import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import Vue from 'vue'

export const useDeviceCodeStore = defineStore('device-code', () => {
  const _deviceCodeMap = useStorage<Record<string, string>>('kintsu-device-code-map', {}, localStorage)

  function addIntoMap(email: string, code: string) {
    Vue.set(_deviceCodeMap.value, email, code)
  }

  function getFromMap(email: string): string | undefined {
    return _deviceCodeMap.value[email]
  }

  function removeFromMap(email: string) {
    Vue.delete(_deviceCodeMap.value, email)
  }

  return {
    _deviceCodeMap,
    addIntoMap,
    getFromMap,
    removeFromMap,
  }
})
